import {useState} from "react"
import {Input, Select, Button} from "antd"
import {EyeOff, Plus} from "lucide-react"
import {APIv1} from "../../../api";
import "./MarketFieldsComponent/MarketFieldsComponent.scss"

const terminalOptions = [
    {label: "pax", value: "pax"},
    {label: "ingenico", value: "ingenico"},
];

const DeviceTerminalFieldsComponent = ({t, data, onChange, userData, disabled = false}) => {
    const [showAdditionalFields, setShowAdditionalFields] = useState(false)
    const [deviceTerminals, setDeviceTerminals] = useState([]);
    const [loading, setLoading] = useState(false);

    const fetchTerminals = async () => {
        setLoading(true);
        try {
            const marketResponse = await APIv1.get('/device/terminal/list/serials/', {
                headers: {
                    Authorization: `Token ${userData.token}`
                },
            });

            setDeviceTerminals(
                marketResponse.data.results.map(item => ({
                    value: item.id,
                    label: item.terminal_serial_number,
                }))
            );

        } catch (err) {
            console.error('Something went wrong with users:', err);
        } finally {
            setLoading(false);
        }
    };

    const handlePlusClick = () => {
        if (disabled) return
        setShowAdditionalFields(true)
    }

    const hideAdditionalFields = () => {
        setShowAdditionalFields(false)
    }

    return (
        <div className="market-fields-container">
            <div className="market-fields-left">
                <div className="create-device__inline-control">
                    <Select
                        className="create-device__control"
                        placeholder={t("pages.devices.addNewDeviceColumns.terminalFields.placeholder1")}
                        optionLabelProp="label"
                        options={deviceTerminals}
                        allowClear
                        autoFocus
                        disabled={disabled}
                        value={data?.id ? {value: data.id, label: data.terminal_serial_number} : undefined}
                        onChange={(val) => {
                            if (!val) {
                                onChange({id: null, terminal_serial_number: null});
                            } else {
                                onChange({id: val.value, terminal_serial_number: val.label});
                            }
                        }}
                        labelInValue
                        dropdownMatchSelectWidth={false}
                        showArrow
                        showSearch
                        loading={loading}
                        filterOption={(input, option) =>
                            option?.label?.toLowerCase().includes(input.toLowerCase())
                        }
                        onDropdownVisibleChange={(open) => {
                            if (open && deviceTerminals.length === 0) {
                                fetchTerminals();
                            }
                        }}
                    />
                    <Button className="create-device__icon-button" icon={<Plus size={16}/>} onClick={handlePlusClick} disabled={disabled}/>
                </div>
            </div>

            {showAdditionalFields && (
                <div className="market-fields-right">
                    <div className="market-fields-controls">
                        <Button
                            type="text"
                            icon={<EyeOff size={16}/>}
                            onClick={hideAdditionalFields}
                            className="toggle-left-button"
                        >
                            {t("pages.devices.addNewDeviceColumns.terminalFields.button1")}
                        </Button>
                    </div>

                    <div className="create-device__field-grid create-device__field-grid--compact">
                        <div className="create-device__field">
                            <div className="create-device__field-label create-device__required-label">{t("pages.devices.addNewDeviceColumns.terminalFields.row1")}</div>
                            <Select
                                className="create-device__control"
                                placeholder='Select a type'
                                optionLabelProp="label"
                                options={terminalOptions}
                                allowClear={true}
                                autoFocus={true}
                                virtual={false}
                                disabled={disabled}
                                value={data.type || undefined}
                                onChange={(value) => onChange({type: value})}
                            />
                        </div>
                        <div className="create-device__field">
                            <div className="create-device__field-label create-device__required-label">{t("pages.devices.addNewDeviceColumns.terminalFields.row2")}</div>
                            <Input
                                className="create-device__control"
                                placeholder="text"
                                allowClear
                                disabled={disabled}
                                value={data.terminal_serial_number || ""}
                                onChange={(e) => onChange({terminal_serial_number: e.target.value})}
                            />
                        </div>
                        <div className="create-device__field">
                            <div className="create-device__field-label create-device__required-label">{t("pages.devices.addNewDeviceColumns.terminalFields.row3")}</div>
                            <Input
                                className="create-device__control"
                                placeholder="text"
                                allowClear
                                disabled={disabled}
                                value={data.tms_id || ""}
                                onChange={(e) => onChange({tms_id: e.target.value})}
                            />
                        </div>
                        <div className="create-device__field">
                            <div className="create-device__field-label">{t("pages.devices.addNewDeviceColumns.terminalFields.row4")}</div>
                            <Input
                                className="create-device__control"
                                placeholder="text"
                                allowClear
                                disabled={disabled}
                                value={data.terminal_model || ""}
                                onChange={(e) => onChange({terminal_model: e.target.value})}
                            />
                        </div>
                        <div className="create-device__field">
                            <div className="create-device__field-label">{t("pages.devices.addNewDeviceColumns.terminalFields.row5")}</div>
                            <Input
                                className="create-device__control"
                                placeholder="text"
                                allowClear
                                disabled={disabled}
                                value={data.ip_address || ""}
                                onChange={(e) => onChange({ip_address: e.target.value})}
                            />
                        </div>
                        <div className="create-device__field">
                            <div className="create-device__field-label">{t("pages.devices.addNewDeviceColumns.terminalFields.row6")}</div>
                            <Input
                                className="create-device__control"
                                placeholder="text"
                                allowClear
                                disabled={disabled}
                                value={data.ip_mask || ""}
                                onChange={(e) => onChange({ip_mask: e.target.value})}
                            />
                        </div>
                        <div className="create-device__field">
                            <div className="create-device__field-label">{t("pages.devices.addNewDeviceColumns.terminalFields.row7")}</div>
                            <Input
                                className="create-device__control"
                                placeholder="text"
                                allowClear
                                disabled={disabled}
                                value={data.gateway || ""}
                                onChange={(e) => onChange({gateway: e.target.value})}
                            />
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}

export default DeviceTerminalFieldsComponent
